import React from 'react';
import Panel from './Panel';
import { IconAlert } from './icons';

const GRAVITY = {
  haute: 'high',
  moyenne: 'mid',
  faible: 'low',
};

function timeOf(iso) {
  try {
    const d = new Date(iso);
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getHours())}:${p(d.getMinutes())}`;
  } catch {
    return '--:--';
  }
}

/** Flux chronologique des anomalies / incidents détectés. */
export default function AnomaliesFeed({ data, delay = 0 }) {
  const items = data?.anomalies || [];

  return (
    <Panel
      icon={IconAlert}
      title="Anomalies détectées"
      sub="Incidents & pics inhabituels"
      badge={`${items.length} actives`}
      delay={delay}
    >
      {items.length === 0 && <div className="empty">Aucune anomalie en cours. 🟢</div>}
      {items.map((a, i) => {
        const g = GRAVITY[a.gravite] || 'mid';
        const last = i === items.length - 1;
        return (
          <div className="anomaly" key={a.id}>
            <div className="anomaly__rail">
              <span className={`anomaly__dot ${g}`} />
              {!last && <span className="anomaly__line" />}
            </div>
            <div className="anomaly__body">
              <div className="anomaly__top">
                <span className="anomaly__type">{a.type.replace(/_/g, ' ')}</span>
                <span className="anomaly__time">{timeOf(a.horodatage)}</span>
              </div>
              <div className="anomaly__desc">{a.description}</div>
              <div className="anomaly__meta">
                <span className="chip">{a.id}</span>
                <span className="chip">{a.zone_id}</span>
              </div>
            </div>
          </div>
        );
      })}
    </Panel>
  );
}
